import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    Typography,
} from '@material-ui/core';

import { PageLayout } from '../../common/components';
import { getBreadCrumb } from '../../common/breadcrumbUtil';
import { patientProgramElementGroups } from '../../common/constants';
import apiUrls from '../../youwell-common/apiUrls';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(4),
    },
    element: {
        marginBottom: theme.spacing(4),
    },
    elementHeading: {
        marginBottom: theme.spacing(2),
        borderBottom: theme.youwell.borders.normal,
        borderBottomColor: theme.palette.secondary.main,
        borderBottomWidth: 4,
        display: 'flex',
        alignItems: 'center',
    },
    elementHeadingTitle: {
        flex: '1 1 auto',
    },
    elementContent: {
        padding: theme.spacing(1, 2),
    },
    print: {
        marginBottom: theme.spacing(2),
        display: 'block',
    },
    underline: {
        color: theme.youwell.colors.secondary,
        borderBottom: theme.youwell.borders.normal,
        borderBottomColor: theme.youwell.colors.secondary,
    },
    noPrints: {
        margin: theme.spacing(2, 0),
    },
});


class PrintFiles extends React.Component {
    render() {
        const {
            classes, translate, currentProgram, clientConfig,
        } = this.props;

        if (!currentProgram) {
            return null;
        }

        const printModules = ((currentProgram.groupedElements && currentProgram.groupedElements[patientProgramElementGroups.main]) || [])
            .map((element) => {
                const tasksWithPrint = element.module?.tasks?.filter(d => !!d.printFileId);
                return {
                    ...element.module,
                    modulePrintFileId: element.module?.printFileId,
                    tasksWithPrint,
                    noPrints: !element.module?.printFileId && !tasksWithPrint?.length,
                };
            });
            // .filter(d => d.modulePrintFileId);

        const hasPrints = printModules.some(d => d.modulePrintFileId);

        return (
            <PageLayout
                breadcrumb={getBreadCrumb(translate('printFiles.heading'), translate, clientConfig)}
            >
                <div className={classes.root}>
                    {hasPrints ? printModules.map(module => (
                        <div className={classes.element} key={module.id}>

                            <div className={classes.elementHeading}>
                                <Typography variant="subtitle1" color="inherit" className={classes.elementHeadingTitle}>
                                    {module.name}
                                </Typography>
                            </div>

                            <div className={classes.elementContent}>
                                {module.noPrints && (
                                    <Typography color="textSecondary" className={classes.print}>
                                        {translate('printFiles.noPrintFileForModule')}
                                    </Typography>
                                )}
                                {module.modulePrintFileId && (
                                    <a href={`${apiUrls.baseUrl}/${apiUrls.media.file}/${module.modulePrintFileId}`} target="_blank" rel="noopener noreferrer" className={classes.print}>
                                        <Typography variant="subtitle1">
                                            <span className={classes.underline}>{translate('printFiles.downloadPdfForModule')}</span>
                                        </Typography>
                                    </a>
                                )}

                                {module.tasksWithPrint?.length > 0 && (
                                    <div className={classes.taskPrints}>
                                        {/* <Typography>
                                            {translate('printFiles.pagesInModule')}
                                        </Typography> */}
                                        {module.tasksWithPrint.map(task => (
                                            <a key={task.id} href={`${apiUrls.baseUrl}/${apiUrls.media.file}/${task.printFileId}`} target="_blank" rel="noopener noreferrer" className={classes.print}>
                                                <Typography variant="subtitle1">
                                                    <span className={classes.underline}>{task.name}</span>
                                                </Typography>
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )) : (
                        <Typography variant="subtitle1" color="textSecondary" className={classes.noPrints}>
                            {translate('printFiles.noPrintFilesAvailable')}
                        </Typography>
                    )}
                </div>
            </PageLayout>
        );
    }
}

PrintFiles.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    clientConfig: PropTypes.object.isRequired,
    currentProgram: PropTypes.object,
};

PrintFiles.defaultProps = {
    currentProgram: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
    currentProgram: state.programStore.currentProgram,
});


export default connect(mapStateToProps)(withStyles(styles)(PrintFiles));
